import { useEffect } from 'react'

type HotkeyConfig = {
  keys: string[]
  callback: () => void
  preventDefault?: boolean
  blockOnInputWithFocus?: boolean
}

export const useHotkeys = (hotkeysConfig: HotkeyConfig[]) => {
  useEffect(() => {
    const pressedKeys = new Set<string>()

    const handleKeyDown = (event: KeyboardEvent) => {
      if (!event.key) return
      const key = event.key.toLowerCase()
      pressedKeys.add(key)

      for (const config of hotkeysConfig) {
        const { keys, callback, preventDefault = false, blockOnInputWithFocus = false } = config

        const allKeysPressed = keys.every((k) => pressedKeys.has(k.toLowerCase()))

        if (allKeysPressed) {
          if (
            blockOnInputWithFocus &&
            (document.activeElement?.tagName === 'INPUT' ||
              document.activeElement?.tagName === 'TEXTAREA' ||
              document.activeElement?.classList.contains('react-datepicker__navigation'))
          ) {
            return
          }

          if (preventDefault) {
            event.preventDefault()
          }

          callback()
        }
      }
    }

    const handleKeyUp = (event: KeyboardEvent) => {
      if (!event.key) return
      pressedKeys.delete(event.key.toLowerCase())
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('keyup', handleKeyUp)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('keyup', handleKeyUp)
    }
  }, [hotkeysConfig])
}
